export const getAspectRatioClass = (aspectRatio: string): string => {
  switch (aspectRatio) {
    case '9:16':
      return 'aspect-[9/16]'
    case '16:9':
      return 'aspect-[16/9]'
    case '1:1':
      return 'aspect-square'
    case '3:4':
      return 'aspect-[3/4]'
    case '4:3':
      return 'aspect-[4/3]'
    case '3:2':
      return 'aspect-[3/2]'
    case '2:3':
      return 'aspect-[2/3]'
    case '4:5':
      return 'aspect-[4/5]'
    case '5:4':
      return 'aspect-[5/4]'
    case '21:9':
      return 'aspect-[21/9]'
    default:
      return 'aspect-square'
  }
}

// 고정 높이 기준 이미지 크기 계산
const FIXED_HEIGHT = 200

interface ImageDimensions {
  width: number
  height: number
}

export const getImageDimensions = (aspectRatio: string): ImageDimensions => {
  const height = FIXED_HEIGHT
  
  switch (aspectRatio) {
    case '16:9':
      return { width: Math.round((16 / 9) * height), height }
    case '9:16':
      return { width: Math.round((9 / 16) * height), height }
    case '1:1':
      return { width: height, height }
    case '3:4':
      return { width: Math.round((3 / 4) * height), height }
    case '4:3':
      return { width: Math.round((4 / 3) * height), height }
    case '3:2':
      return { width: Math.round((3 / 2) * height), height }
    case '2:3':
      return { width: Math.round((2 / 3) * height), height }
    case '4:5':
      return { width: Math.round((4 / 5) * height), height }
    case '5:4':
      return { width: Math.round((5 / 4) * height), height }
    case '21:9':
      return { width: Math.round((21 / 9) * height), height }
    default:
      return { width: height, height }
  }
}

export const getFixedHeightImageStyle = (aspectRatio: string): React.CSSProperties => {
  const dimensions = getImageDimensions(aspectRatio)
  return {
    width: `${dimensions.width}px`,
    height: `${dimensions.height}px`,
    flexShrink: 0,
  }
}

export interface ImageData {
  jobId: number
  resultUrl: string
  requestType: 'image'
  userPrompt: string
  aspectRatio: string
  imageMode: string
  resolution: string
  durationSeconds: number
  status: 'pending' | 'processing' | 'completed' | 'failed'
  createdAt: string
  completedAt: string
  requestId: number
  pointCost: number
  // 호환성을 위한 추가 필드들
  id?: string | number
  url?: string
  prompt?: string
  type?: 'completed' | 'pending' | 'processing' | 'failed'
}